/** Cache-bust public brand SVG/PNG paths after each Vite build. */
export function brandAssetUrl(path: string): string {
  const stamp = import.meta.env.VITE_BUILD_STAMP;
  if (!stamp || !path) return path;
  const sep = path.includes('?') ? '&' : '?';
  return `${path}${sep}v=${stamp}`;
}
